// ============================================================
// CHANGELOG / NOVIDADES
// ------------------------------------------------------------
// Controle do pop-up de novidades por VERSÃO.
//
// Como anunciar algo novo:
//   1. Atualize CHANGELOG_VERSAO para a data de hoje (formato ISO AAAA-MM-DD).
//   2. Preencha CHANGELOG_ITENS com os itens desta versão.
//   3. Rebuild do frontend.
// O pop-up reaparece UMA vez para cada usuário cuja última versão confirmada
// seja diferente da atual.
//
// Enquanto CHANGELOG_ITENS estiver vazio, o pop-up NÃO vai ao ar (placeholder
// seguro) — o ponto de montagem só renderiza se houver itens.
// ============================================================

export const CHANGELOG_VERSAO = '2026-11-01';

// Cada item: { titulo: string, descricao: string } (apenasAdmin: true = só o escritório vê)
// Deixe vazio ([]) para não exibir nada.
export const CHANGELOG_ITENS = [
  {
    titulo: 'Aviso ao referenciar cupom fiscal ou nota de consumidor',
    descricao: 'Ao conferir a nota, o sistema avisa se alguma nota referenciada for uma nota de consumidor (NFC-e) ou um cupom fiscal eletrônico (CF-e SAT). A partir de 14/12/2026 a SEFAZ deixa de aceitar essa referência em nota de saída (exceto nota complementar ou de devolução), e a nota só poderá ser emitida depois de retirar a chave.',
  },
  {
    titulo: 'Simples Nacional: dados de 2027 preenchidos pelo escritório',
    descricao: 'O escritório passa a preencher os dados que as empresas do Simples Nacional vão usar nas notas a partir de 2027, como a atividade de cada produto. Para quem emite, nada muda em 2026; no cadastro do produto aparece, só para consulta, a atividade do Simples definida pelo escritório.',
  },
  {
    titulo: 'DANFE com código de barras maior',
    descricao: 'O código de barras do DANFE ficou maior, conforme a nova norma da Receita para o CNPJ com letras. Para caber, o quadro com os dados da empresa ficou mais estreito; o restante do documento não muda.',
  },
  {
    titulo: 'Nota de exportação',
    descricao: 'Agora é possível emitir a nota de venda para cliente do exterior: na emissão aparece a seção "Exportação" para informar onde a mercadoria embarca, e o sistema confere os códigos antes de enviar. Casos como drawback e exportação de mercadoria recebida com fim específico também são aceitos.',
  },
  {
    titulo: 'Conferência do formato da nota antes de enviar',
    descricao: 'Antes de enviar à SEFAZ, o sistema confere se cada campo da nota está no formato exigido e, se algo estiver errado, mostra qual campo e de qual item corrigir, sem enviar. As recusas da SEFAZ também passaram a vir com explicação em português e o que fazer.',
  },
];
